import { render, staticRenderFns } from "./NoticeCreate.vue?vue&type=template&id=24c0d3d8&scoped=true&"
import script from "./NoticeCreate.vue?vue&type=script&lang=js&"
export * from "./NoticeCreate.vue?vue&type=script&lang=js&"
import style0 from "./NoticeCreate.vue?vue&type=style&index=0&id=24c0d3d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c0d3d8",
  null
  
)

export default component.exports